export const L_MV = 'b_daodian_lowcode_jpln7ijh_mv';
export const L_MC = 'b_daodian_lowcode_3vegaex4_mc';
export const R_MV = 'b_daodian_lowcode_wbngzrnt_mv';
export const R_MC = 'b_daodian_lowcode_y1fcnum1_mc';
export const TYPE = {
    RESERVATION: 1,
    // 预约抢
    STRATEGY: 2 // 包有票
};
export const PlatformType = {
    mtApp: "mtApp",
    mtAppWebView: "mtAppWebview",
    mtMinaWebview: "mtMinaWebview",
    dpApp: "dpApp",
    dpMinaWebview: "dpMinaWebview",
    dpAppWebView: "dpAppWebView",
    pc: 'pc',
    h5: "h5"
};
export const Systems = {};
